export { CookieManagementPage as default } from '@/components/pages/CookieManagement'
